exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selection-mode[data-v-825f58f8] {\n  margin-bottom: 15px;\n}", ""]);

// exports
